import Module from './module'
import render from '../components/render'
import stage from '../components/stage'
import gsap from 'gsap'
import autosize from 'autosize'
import 'jquery.scrollto'

var objectFitImages = require('object-fit-images');

class App extends Module{

  constructor(element, $) {
    super()
    this.init()
  }

  init() {

      objectFitImages();

      this.menu = $('.menu')


      this.addEvents()

      this.resizeQue = this.resize.bind(this)
      stage.on("stage:resize", this.resizeQue);
      this.renderQue = this.render.bind(this)
      stage.on("stage:scroll", this.renderQue);
      this.resize(stage);


  }

  addEvents(){


      this.menu.on('click', (e)=>{
          e.preventDefault()

      })

  }


  resize(e){

    // this.boxes.each((i, el) => {
    //
    //     const box = $(el)
    //     const rect = box.offset()
    //     const height = box.height()
    //
    //
    //     box.data('bottom', rect.top  + height )
    //     box.data('top', rect.top )
    // })
    //
    // this.render(stage)


  }

  renderQueCall(){

  }

  render(e){

    // this.boxes.each((i, el) => {
    //
    //   const box = $(el)
    //   const index = box.data('height')
    //   const token = box.data('top')
    //   const inview =  e.scrolltop + e.h > token && e.scrolltop < token + index;
    //   const loading = e.scrolltop <= token - e.h;
    //
    //   box.toggleClass('in-view', inview)
    //   box.toggleClass('hide', loading)
    //
    // })

  }

  validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  mailchimp(email, url) {

		var data = {
			'EMAIL': email,
			utf8: '✓'
		};

		var promise = $.ajax({
				url: url ,
				method: 'post',
				data: data,
				cache       : false,
				dataType    : 'jsonp',
				jsonp: 'c',
				contentType: "application/json; charset=utf-8"
		})

		return promise;
	}

}

App.selector = 'html'
module.exports = App
